import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function AssetNavButDash( props ){
    //console.debug("RTS Break AssetNavButDash");

    const history = useNavigate();
    const {setCurFilter} = useSessionContext();

    function handleDashboardClick(e) {
        setCurFilter(null);
        props.setOpenDrawerFx(false);
        history("/InventoryShipments");
    }

    if(props.mode==="NavDrawer"){
        return (
            <>
            <ListItem button key="Shipments" onClick={handleDashboardClick}>
                <ListItemText primary="Shipments" />
            </ListItem>
            </>
        )
    }

    return (
        <>
        <Button
            key='Shipments'
            onClick={handleDashboardClick}
            sx={{ my: 2, mx: 1, color: 'white', textTransform: 'unset' }}
        >
            Shipments
        </Button>
        </>
    );
}



